import styled from "styled-components";

const Divider = styled.hr`
  display: block;
  margin: 30px 0;
  border: 1px solid #707070;
  opacity: 0.22;
`;

export default Divider;
